import { useState } from "react";
import { CaretLeft, CaretRight } from "@phosphor-icons/react";

export const BeforeAfterSlider = ({ before, after, altBefore, altAfter, accent = "#2563eb", testid = "before-after" }) => {
  const [pos, setPos] = useState(50);
  return (
    <figure className="m-0">
      <div className="relative w-full aspect-[3/2] rounded-2xl overflow-hidden select-none bg-slate-200 shadow-sm" data-testid={testid}>
        <img src={after} alt={altAfter} className="absolute inset-0 w-full h-full object-cover" loading="lazy" draggable="false" />
        <div className="absolute inset-0" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
          <img src={before} alt={altBefore} className="absolute inset-0 w-full h-full object-cover" loading="lazy" draggable="false" />
        </div>
        <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-black/60 text-white text-[11px] font-bold uppercase tracking-widest pointer-events-none">
          Vorher
        </span>
        <span className="absolute top-3 right-3 px-2.5 py-1 rounded-full text-white text-[11px] font-bold uppercase tracking-widest pointer-events-none" style={{ backgroundColor: accent }}>
          Nachher
        </span>
        <div className="absolute inset-y-0 pointer-events-none" style={{ left: `${pos}%` }}>
          <div className="absolute inset-y-0 -ml-px w-0.5 bg-white shadow-[0_0_6px_rgba(0,0,0,0.4)]" />
          <div className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-10 h-10 rounded-full bg-white shadow-lg flex items-center justify-center gap-0.5" style={{ color: accent }}>
            <CaretLeft size={13} weight="bold" />
            <CaretRight size={13} weight="bold" />
          </div>
        </div>
        <input
          type="range"
          min="0"
          max="100"
          value={pos}
          onChange={(e) => setPos(Number(e.target.value))}
          aria-label="Vorher-Nachher-Vergleich verschieben"
          className="absolute inset-0 w-full h-full opacity-0 cursor-ew-resize"
          data-testid={`${testid}-range`}
        />
      </div>
    </figure>
  );
};

export default BeforeAfterSlider;
